import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function generatePdf(cadastros, selectEquipe, microArea) {
  const titlePdf = 'Aedes aegypti'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, selectEquipe.no_equipe)
  const descriptionPdf =
    'Atendimentos e visitas em cidadãos com presença do vetor transmissor da dengue'
  const headersPdf = [
    'NOME',
    'DATA DE NASCIMENTO',
    'MÃE',
    'MA',
    'ATENDIMENTO',
    'VISITA',
    'DOCUMENTO',
  ]
  const dataPdf = cadastros.map((cadastro) => {
    const documentoParts = []
    if (cadastro.nu_cpf) documentoParts.push(`CPF ${cadastro.nu_cpf}`)
    if (cadastro.nu_cns) documentoParts.push(`CNS ${cadastro.nu_cns}`)

    return {
      no_cidadao: cadastro.no_cidadao,
      dt_nascimento: utils.methods.formatDate(cadastro.dt_nascimento),
      no_mae: cadastro.no_mae,
      micro_area: cadastro.micro_area,
      ultimo_atendimento: utils.methods.formatDate(cadastro.ultimo_atendimento),
      dt_ultima_visita: utils.methods.formatDate(cadastro.dt_ultima_visita),
      documento: documentoParts.join('\n'),
      dias: cadastro.dias,
    }
  })

  const doc = new jsPDF(utils.methods.encryptionPdf())
  const table = utils.methods.createTablePdf(dataPdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )
      const equipeInfo = [
        { label: 'Equipe', value: selectEquipe.no_equipe },
        { label: 'CNES', value: selectEquipe.nu_cnes },
        { label: 'INE', value: selectEquipe.ine_esf_eap },
        { label: 'Microárea', value: microArea },
      ]
      verticalPosition = utils.methods.bodyPdf(
        doc,
        equipeInfo,
        verticalPosition
      )
      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: (data) => {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
            return
          }
          let dias = parseInt(data.row.raw[7])
          if (dias <= 30) {
            doc.setTextColor(194, 10, 16)
          } else {
            doc.setTextColor(2, 99, 57)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', { position: 'topRight' })
    })
}

export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    const dias = parseInt(item.dias)
    if (dias <= 30) {
      return true
    } else {
      return false
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    const dias = parseInt(item.dias)
    if (dias > 30) {
      return true
    } else {
      return false
    }
  })

  return filtro
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  'Útimo atendimento': {
    field: 'ultimo_atendimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  'Útima visita': {
    field: 'dt_ultima_visita',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
}
